import './styles.scss'
import React from 'react'
import { hot } from 'react-hot-loader'
import { useValues } from 'kea'

import Guest from './guest'
import Invite from './invite'

import sceneLogic from './logic'

function Index () {
  const { isLoggedIn } = useValues(sceneLogic)
  return <div data-attr='invites-container'>{isLoggedIn ? <Invite /> : <Guest />}</div>
}
export default hot(module)(Index)
